module.exports = __webpack_public_path__ + "static/media/terms.4220f7f0.md";